import React, { createContext, useEffect, useState } from "react";

export const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [cartItems, setCartItems] = useState([]);

  useEffect(() => {
  const storedCart = localStorage.getItem("cart");
  if (storedCart) {
    const parsedCart = JSON.parse(storedCart);
    setCartItems(parsedCart);
    console.log("Cart loaded from localStorage:", parsedCart);
  }
}, []);

  // Save cart to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem("cart", JSON.stringify(cartItems));
  }, [cartItems]);

  const addToCart = (item) => {
  setCartItems((prevItems) => {
    const isAlreadyInCart = prevItems.some((i) => i.Id === item.Id);
    if (!isAlreadyInCart) {
      const updatedCart = [...prevItems, item];
      return updatedCart; // 👈 Don't manually write to localStorage here
    } else {
      console.log("Item already in cart:", item);
      return prevItems;
    }
  });
};

  const removeFromCart = (id) => {
    setCartItems((prevItems) => prevItems.filter((item) => item.Id !== id));
  };

  const clearCart = () => {
    setCartItems([]);
    localStorage.removeItem("cart");
  };

  return (
    <CartContext.Provider
      value={{ cartItems, addToCart, removeFromCart, clearCart }}
    >
      {children}
    </CartContext.Provider>
  );
};